<div class="main-container">

  <div class="title">
    <span class="title-text">Guest History</span>
    <p class="small-title">Look up a guest's stay history by Aadhaar number.</p>
  </div>

  <div class="searchBar">
    <div class="each-div">
      <span class="drop-title">Aadhaar Number</span>
      <input type="text" class="text-box-active" [formControl]="aadhaar" />
    </div>
    <div class="btn">
      <button type="button" class="ac-primary-btn" (click)="search()">Search</button>
    </div>
  </div>

  @for(bucket of bucketDefs; track bucket.key){
  @if(rows(bucket.key).length > 0){
  <div class="bucket">
    <div class="bucket-title">{{ bucket.label }} ({{ rows(bucket.key).length }})</div>
    <div class="table-container">
      <table class="table">
        <thead class="table-head">
          <tr>
            <th>Booking ID</th>
            <th>Family Code</th>
            <th>Type</th>
            <th>Accommodation</th>
            <th>Guests</th>
            <th>From</th>
            <th>To</th>
            <th>Status</th>
            <th>Stage</th>
          </tr>
        </thead>
        <tbody class="table-body">
          @for(row of rows(bucket.key); track row.bookingId){
          <tr>
            <td>{{ row.bookingId }}</td>
            <td>{{ row.familyCode }}</td>
            <td>{{ row.bookingType || '-' }}</td>
            <td>{{ row.accommodationType || '-' }}</td>
            <td>{{ row.guestCount }}</td>
            <td>{{ row.fromDate }}</td>
            <td>{{ row.toDate }}</td>
            <td>{{ row.status }}</td>
            <td>{{ row.lifecycleStatus }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
  }

  @if(hasSearched && !hasAny){
  <p class="empty">No stay history found for this Aadhaar number.</p>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
